export default "__VITE_ASSET__$jcLPmNv__"